import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import ActionTypes from "../../../constants/ActionTypes";

const setScrollPositionToLocalStorageMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  if (action.type.includes(ActionTypes.SCROLL.SET_POSITION)) {
    const localStoragePositions = localStorage.getItem("scrollPositionOnProductList");
    let scrollPositions = localStoragePositions ? JSON.parse(localStoragePositions) : {};

    scrollPositions = {
      ...scrollPositions,
      [action.payload.deviceType]: action.payload.scrollPosition,
    };

    localStorage.setItem("scrollPositionOnProductList", JSON.stringify(scrollPositions));
  }
};

export default setScrollPositionToLocalStorageMiddleware;
